
const navItems = [
  { id: 'accueil', label: 'Accueil' },
  { id: 'services', label: 'Services' },
  { id: 'apropos', label: 'À Propos' },
  { id: 'contact', label: 'Contact' }
];

const DesktopNav = ({ onNavigate }) => (
  <nav className="desktop-nav">
    {navItems.map((item) => (
      <button
        key={item.id}
        onClick={() => onNavigate(item.id)}
        className="nav-link"
      >
        {item.label}
      </button>
    ))}
  </nav>
);

export default DesktopNav;
